<mat-accordion class="management-accordion">
    <mat-expansion-panel [expanded]="displayMode === DisplayMode.List" [disabled]="true" hideToggle class="panel-list" [ngClass]="{ expanded: displayMode === DisplayMode.Form }">
        <mat-expansion-panel-header
            collapsedHeight="48px"
            expandedHeight="48px"
            [ngClass]="{ 'events-inactive': !context?.apiConfigurationContext.formVisible, 'events-active': context?.apiConfigurationContext.formVisible }"
            class="detail-header">
            <app-list-header
                [createRight]="displayAddbuttom"
                titleText="Configurations des APIs"
                createIconText="Ajouter une configuration"
                importDatasourceName="processdefinitions"
                (created)="onItemCreated()"
                (exported)="onItemsExported()"
                (imported)="onItemsImported()"
                (helped)="onHelpRequested()"></app-list-header>
        </mat-expansion-panel-header>

        <app-api-configurations-list
            #itemsList
            (itemSelected)="onItemSelected($event)"
            (itemDisplayed)="onItemDisplayed($event)"
            (itemEdited)="onItemEdited($event)"
            (itemDeleted)="onItemDeleted($event)"
            (itemDuplicated)="onItemDuplicated($event)"></app-api-configurations-list>
    </mat-expansion-panel>
    @if (displayMode === DisplayMode.Form) {
        <mat-expansion-panel
            [disabled]="!context?.apiConfigurationContext.formVisible"
            [expanded]="displayMode === DisplayMode.Form"
            [disabled]="true"
            hideToggle
            class="panel-form">
            <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px" class="detail-header">
                <app-detail-header
                    [editRight]="displayEditbuttom"
                    [formMode]="context?.apiConfigurationContext.mode"
                    [displayName]="context?.apiConfigurationContext.restApiConfiguration.name"
                    [id]="context?.apiConfigurationContext.restApiConfiguration.id"
                    (displayed)="onItemDisplayed(context?.apiConfigurationContext.restApiConfiguration)"
                    (edited)="onItemEdited(context?.apiConfigurationContext.restApiConfiguration)"
                    (helped)="onHelpRequested()"
                    (backToList)="onBackToList()"></app-detail-header>
            </mat-expansion-panel-header>
            <app-api-configurations-detail [context]="context" (apiConfigurationUpdated)="onItemUpdated($event)" (canceled)="onBackToList()"></app-api-configurations-detail>
        </mat-expansion-panel>
    }
</mat-accordion>

<ngx-spinner name="apiConfiguration-spinner" bdColor="var(--avm-color-30)" color="var(--spinner-color)" [fullScreen]="true" type="timer" size="medium"></ngx-spinner>
